import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import es from './locales/es.json'
import en from './locales/en.json'
import pt from './locales/pt.json'

/**
 * Briefer i18n.
 *
 * Spanish is the PRIMARY locale (per CLAUDE.md i18n discipline and brand
 * voice guide §4 — "Spanish-first."). English second; Portuguese third
 * (placeholder copy of `es.json` until translated by Marketing). The
 * detector inspects `localStorage` first (the topbar writes there when
 * the user clicks a flag chip), then falls back to the browser locale,
 * then Spanish.
 *
 * Note: `lng` is intentionally NOT set, so the detector wins. Setting
 * `lng: 'es'` here used to force Spanish on every reload, blocking the
 * topbar's language switcher.
 */
export const SUPPORTED_LOCALES = ['es', 'en', 'pt'] as const
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
      pt: { translation: pt },
    },
    fallbackLng: 'es',
    supportedLngs: SUPPORTED_LOCALES,
    nonExplicitSupportedLngs: true, // accept 'pt-BR' → 'pt', etc.
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'briefer.lang',
    },
  })

export default i18n
